<template>
  <div class="m-0 p-0">
    <ValidationProvider v-if="validation" :rules="validation" v-slot="{ errors }" :name="label">
      <div class="selectInputWrapper">
        <label v-if="labelOnTop" class="input-label">
          {{$t(label)}}
          <span v-if="validation.includes('required')">*</span>
          <span v-else>{{$t('(optional)')}}</span>
        </label>
        <select
          v-model="localSelected"
          required
          ref="select"
          :name="name"
          :id="id"
          class="form-control"
          @change="updateComponent"
          :class="{'is-invalid': errors.length}"
          :style="styles"
          :aria-describedby="errors.length ? `${id}-error` : null"
          :aria-invalid="errors.length ? 'true' : 'false'"
        >
          <option value disabled :selected="!selectedValue" hidden>{{ $t(placeholder) }}</option>
          <option
            v-for="option in options"
            :key="option.value"
            :selected="option.value == selectedValue"
            :disabled="option.disabled"
            :value="option.value"
          >{{ $t(option.text) }}</option>
        </select>
      </div>
      <div :id="`${id}-error`" class="validation-error" role="alert" aria-live="assertive" v-if="errors.length">{{errors[0]}}</div>
    </ValidationProvider>
    <template v-else>
      <div class="selectInputWrapper">
        <select
          class="form-control"
          v-model="localSelected"
          required
          ref="select"
          :name="name"
          :id="id"
          @change="updateComponent"
        >
          <option value disabled :selected="!selectedValue" hidden></option>
          <option
            v-for="option in options"
            :key="option.value"
            :selected="option.value == selectedValue"
            :disabled="option.disabled"
            :value="option.value"
          >{{option.text}}</option>
        </select>
        <span class="floating-label">{{ $t(placeholder) }}</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "select-input",
  data () {
    return {
      localSelected: this.selectedValue || ""
    };
  },
  props: {
    field: {
      required: false,
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    selectedValue: {
      type: String,
      required: false,
      default: ""
    },
    placeholder: {
      type: String,
      required: false,
      default: "Select Something"
    },
    validation: {
      type: String,
      required: false
    },
    styles: {
      type: Object,
      required: false,
      default: () => {}
    },
    labelOnTop: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateComponent (event) {
      this.$refs.select.style.color = "#000";
      this.$emit("component-updated", {
        text: event.target.value
      });
      this.$emit("input", event.target.value);
      this.$eventHub.$emit("checkCountryForPLZ", event.target.value);
    }
  }
};
</script>

<style scoped lang="scss">
select {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  outline: 0;
  box-shadow: none;
  transition: border-color 0.15s;
  border-radius: var(--field-radius);
  border: 1px solid #707070;
  box-sizing: border-box !important;
  height: 50px;
  cursor: pointer;
  width: 100%;
  font-size: 14px;
  color: #000;
}

.floating-label {
  position: absolute;
  top: 50%;
  left: 12px;
  transition: transform 0.1s;
  pointer-events: none;
  transform-origin: 0 100%;
  transform: translateY(-50%);

  font: normal normal 300 16px/22px 'Plus Jakarta Sans';
  letter-spacing: 0px;
  color: #1B1B1B;
  opacity: 0.5;

}

select:focus + .floating-label,
select.visited + .floating-label,
select:not(:focus):valid ~ .floating-label {
  transform: translateY(-145%) scale(0.7);
}

</style>
